export default function TourOperatorList(){
    return (<>tour-operators</>)
}